import { createFeatureSelector, createSelector } from '@ngrx/store';

import { configFeatureKey, State } from '../reducers/config.reducer';

export const selectConfigFeature = createFeatureSelector<State>(configFeatureKey);

export const selectLoaded = createSelector(selectConfigFeature, (state) => state.loaded);

export const selectLoadError = createSelector(selectConfigFeature, (state) => state.error);

export const selectGoogleMapsAPIKey = createSelector(selectConfigFeature, (state) => state.googleMapsApiKey);

export const selectTerm = createSelector(selectConfigFeature, (state) => state.term);

export const selectTermDescription = createSelector(selectTerm, (state) => state.description);

export const selectTermVersion = createSelector(selectTerm, (state) => state.version);
